import { render } from "./iconEdit.svg?vue&type=template&id=12ab8c2d"
const script = {}

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__